import { SocketConfig, SocketRequestHelper } from './socketRequestHelper';
import { SocketResponse } from '@/types/socketResponse.type';

export const SocketRequestHelperInstance = new SocketRequestHelper();

export function SocketRequest<T = unknown, R = unknown>(
  eventName: string,
  config: SocketConfig<T>,
): Promise<SocketResponse<R>> {
  return SocketRequestHelperInstance.emit(eventName, config);
}
